@if (notification$ | async; as notification) {
  <ng-container>
    <nexweb-decline-form
      [notification]="notification"
      [labels]="labels"
      [heading]="heading"
      [dateTimeFormat]="dateTimeFormat"></nexweb-decline-form>
  </ng-container>
}
